const SERVICE = 'setting-service'

const getCampaignListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/campaigns', params)

const createCampaignApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/campaigns')

const updateCampaignApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/campaigns/${id}`)

const deleteCampaignApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/campaigns/${id}`)

const getRouteListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/signup', params)

const createRouteApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/signup')

const updateRouteApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/signup/${id}`)

const deleteRouteApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/signup/${id}`)

const doTestAudioCallApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/call')

const getPriorityTeamListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/prority', params)

const getPriorityTeamDetailApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/admin/prority/${id}`)

const createPriorityTeamApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/prority')

const updatePriorityTeamApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/prority/${id}`)

const addDoctorToPriorityTeamApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/prority/${id}/doctor`)

const deletePriorityTeamApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/prority/${id}`)

module.exports = {
  getCampaignListApi,
  createCampaignApi,
  updateCampaignApi,
  deleteCampaignApi,
  getRouteListApi,
  createRouteApi,
  updateRouteApi,
  deleteRouteApi,
  doTestAudioCallApi,
  getPriorityTeamListApi,
  getPriorityTeamDetailApi,
  createPriorityTeamApi,
  updatePriorityTeamApi,
  addDoctorToPriorityTeamApi,
  deletePriorityTeamApi,
}
